/**
 * Used with the webpack.DefinePlugin to pull in the package.json version
 */
declare const __VERSION__: string;

export const VERSION = __VERSION__;
